module.exports = __webpack_public_path__ + "img/7d4e97fcc9b1c4fc8f7fc98168d0338f.0677c3ed.png";